<template>
  <IframeCmp type="118" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 已签收应收报表
  name: 'ReceivedReceivablesReport',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
